export const LIST_USERS = 'LIST_USERS';
export const LIST_USERS_OPTIONS = 'LIST_USERS_OPTIONS';
export const NEW_VALUES_USERS = 'NEW_VALUES_USERS';
export const LIST_CATEGORIES = 'LIST_CATEGORIES';
export const NEW_VALUES_CATEGORIES = 'NEW_VALUES_CATEGORIES';
export const LIST_OPTIONS = 'LIST_OPTIONS';
export const LIST_PENDING = 'LIST_PENDING';
export const NEW_VALUES_PENDING = 'NEW_VALUES_PENDING';
export const LIST_RESOLVED = 'LIST_RESOLVED';
